<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav class="pull-left">
      
      </nav>
     
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/ContentFooter.vue